import React from 'react';
import { Button, Form, Input, message } from 'antd';
import logoImg from '@/assets/images/logo.png';
import { login } from '@/api/user';
import Cookies from 'js-cookie';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styles from './index.module.scss';

const Login = () => {
  const [form] = Form.useForm();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get('redirect') || '/';

  const onFinish = async (values: any) => {
    login(values).then(res => {
      message.success('登录成功');

      Cookies.set('token', res);
      window.location.href = redirect;
    });
  };

  return (
    <div className={`${styles.page} relative flex flex-col items-center justify-center h-screen`}>
      <img src={logoImg} width={320} className="absolute top-2 left-2" />
      <div className={`${styles.card} p-8 w-96`}>
        <h1 className="text-3xl text-center font-bold mb-12">欢迎登录</h1>
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Form.Item name="username" rules={[{ required: true, message: '请输入用户名/邮箱号' }]}>
            <Input size="large" placeholder="请输入用户名/邮箱号" />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true, message: '请输入密码' }]}>
            <Input.Password size="large" placeholder="请输入密码" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" className="w-full" size="large" htmlType="submit">
              登录/注册
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default Login;
